import { MarketView } from '@api-proxies';
import { MarketService } from '@http/clients/market.service';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class MarketEntity<TEntityDestination>
    implements IComponentEditorEntity<MarketView, TEntityDestination>
{
    constructor(private readonly marketService: MarketService) {}

    abstract toDestination(entity: MarketView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): MarketView;

    async getSource(): Promise<MarketView[]> {
        return await this.marketService.getAll();
    }
}
